import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';
import { checkChangeBudgetActionData } from '../../utils/helpers';

const CreateChangeBidAmount = () => {
  const dispatch = useDispatch();
  const actionType = 'CHANGE_BID_AMOUNT';
  const { actionCreatedChangeBidAmount, actionCreatedChangeBidAmountLoading } = useSelector((state) => state.general);
  const [actionData, setActionData] = useState({
    useFixedBudget: false,
    useMaxBudget: false,
    useMinBudget: false,
    maxBudget: 0,
    minBudget: 0,
  });
  const [error, setError] = useState({});

  if (actionCreatedChangeBidAmount?._id) {
    dispatch(generalSet({ reduxField: 'actionCreatedChangeBidAmount', value: {} }));
    window.location.href = '/actions';
  }
  return (
    <>
      <div>
        <Link to='/CreateAction' className='btn btn-outline-dark'>
          Change Action Type
        </Link>
      </div>
      <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
        <div className='row d-flex justify-content-center border-bottom'>
          <h1>
            Create Action: <span className='text-primary'>Change Bid Amount</span>
          </h1>
        </div>
        <div className='row d-flex justify-content-center mt-4'>
          <div className='col-md-6'>
            <input
              type='text'
              className='form-control'
              placeholder='Action name...'
              style={{ textAlign: 'center' }}
              onChange={(e) => setActionData({ ...actionData, name: e.target.value })}
            />
          </div>
        </div>
        <div className='row d-flex justify-content-center mt-4'>
          <div className='col-md-6 d-flex justify-content-center'>
            <input
              type='checkbox'
              className='mr-2'
              placeholder='Action name...'
              style={{ textAlign: 'center' }}
              onChange={(e) => setActionData({ ...actionData, useFixedBudget: e.target.checked })}
            />
            Use Fixed Budget
          </div>
        </div>
        {actionData.useFixedBudget ? (
          <>
            <div className='row d-flex justify-content-center mt-2'>
              <div className='col-md-2'>
                <input
                  type='number'
                  className='form-control'
                  placeholder='Fixed Value'
                  style={{ textAlign: 'center' }}
                  onChange={(e) => setActionData({ ...actionData, fixedValue: e.target.value })}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <div className='row d-flex justify-content-center mt-2'>
              <div className='col-md-6 d-flex justify-content-center'>
                <button
                  className={`btn btn${actionData.unit === 'percentage' ? '' : '-outline'}-primary m-2`}
                  onClick={() => setActionData({ ...actionData, unit: 'percentage' })}
                >
                  Percentage
                </button>
                <button
                  className={`btn btn${actionData.unit === 'amount' ? '' : '-outline'}-primary m-2`}
                  onClick={() => setActionData({ ...actionData, unit: 'amount' })}
                >
                  Amount
                </button>
              </div>
            </div>
            <div className='row d-flex justify-content-center mt-2'>
              <div className='col-md-2'>
                <input
                  type='number'
                  className='form-control'
                  placeholder='Value'
                  style={{ textAlign: 'center' }}
                  onChange={(e) => setActionData({ ...actionData, value: e.target.value })}
                />
              </div>
            </div>
            <div className='row d-flex justify-content-center mt-4'>
              <div className='col-md-12 d-flex justify-content-center'>
                <div className='btn-group'>
                  <input
                    type='checkbox'
                    className='mr-2'
                    style={{ textAlign: 'center' }}
                    onChange={(e) => setActionData({ ...actionData, useMaxBudget: e.target.checked })}
                  />
                  <span>Use Max Budget</span>
                </div>
              </div>
              {actionData.useMaxBudget ? (
                <>
                  <div className='col-md-2 d-flex justify-content-center mt-1'>
                    <input
                      type='number'
                      className='form-control'
                      placeholder='Value'
                      defaultValue={0}
                      style={{ textAlign: 'center' }}
                      onChange={(e) => setActionData({ ...actionData, maxBudget: e.target.value || 0 })}
                    />
                  </div>
                </>
              ) : null}
            </div>
            <div className='row d-flex justify-content-center mt-4'>
              <div className='col-md-12 d-flex justify-content-center'>
                <div className='btn-group'>
                  <input
                    type='checkbox'
                    className='mr-2'
                    style={{ textAlign: 'center' }}
                    onChange={(e) => setActionData({ ...actionData, useMinBudget: e.target.checked })}
                  />
                  <span>Use Min Budget</span>
                </div>
              </div>
              {actionData.useMinBudget ? (
                <>
                  <div className='col-md-2 d-flex justify-content-center mt-1'>
                    <input
                      type='number'
                      className='form-control'
                      placeholder='Value'
                      defaultValue={0}
                      style={{ textAlign: 'center' }}
                      onChange={(e) => setActionData({ ...actionData, minBudget: e.target.value || 0 })}
                    />
                  </div>
                </>
              ) : null}
            </div>
          </>
        )}
        <>
          <div className='row d-flex justify-content-center mt-4' data-aos='fade-up' data-aos-delay='200'>
            <button
              className='btn btn-outline-primary'
              disabled={actionCreatedChangeBidAmountLoading}
              onClick={() => {
                const checkResult = checkChangeBudgetActionData(actionData);
                if (checkResult.error) {
                  setError({ msg: checkResult.msg });
                  return;
                }
                if (checkResult.success) {
                  setError({});

                  dispatch(generalSet({ reduxField: 'actionCreatedChangeBidAmountLoading', value: true }));
                  dispatch(
                    apiAction({
                      route: 'actions/createAction',
                      reduxField: 'actionCreatedChangeBidAmount',
                      actionType,
                      actionData,
                      setLoading: 'actionCreatedChangeBidAmountLoading',
                    })
                  );
                }
              }}
            >
              Create Action
            </button>
          </div>
          {error.msg ? (
            <div className='row d-flex justify-content-center mt-4' data-aos='fade-up' data-aos-delay='200'>
              <div className='alert alert-danger' role='alert'>
                {error.msg}
              </div>
            </div>
          ) : null}
        </>
      </div>
    </>
  );
};

export default CreateChangeBidAmount;
